const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = 'zeevogo-analytics-consent';

let initialized = false;

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    return null;
  }
}

export function setConsent(granted) {
  try {
    localStorage.setItem(CONSENT_KEY, granted ? 'granted' : 'denied');
  } catch (e) {}

  if (granted) {
    initAnalytics();
  }
}

export function initAnalytics() {
  if (initialized || !MEASUREMENT_ID || getConsent() !== 'granted') return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  // send_page_view: false — SPA route changes are tracked manually via trackPageView,
  // so the automatic pageview on script load would otherwise double-count the first hit.
  window.gtag('config', MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

export function trackPageView(path, title) {
  window.gtag?.('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  window.gtag?.('event', name, params);
}

export const trackApplyNow = (job) =>
  trackEvent('apply_now_click', { job_id: job.id, job_title: job.role, job_country: job.country });

export const trackCountryFilter = (country) => trackEvent('country_filter_select', { country });

export const trackPartnershipSubmit = (type, status) =>
  trackEvent('generate_lead', { partnership_type: type, status });

export const trackTrackerLookup = () => trackEvent('tracker_lookup_submit', {});

export const trackCtaClick = (label, destination) =>
  trackEvent('cta_click', { cta_label: label, destination });

export const trackCallClick = () => trackEvent('call_click', {});

export const trackSocialClick = (platform) => trackEvent('social_link_click', { platform });
